import { isProduction } from '/imports/config/client';
import { end, formatRoute, lit, url } from '/imports/modules/Routing';

export const indexRoute = url(end);
export const indexLink = formatRoute(indexRoute)({});
export const infoRoute = url(lit('info'), end);

export const loginRoute = url(lit('login'), end);

export const loginDemoRoute = url(lit('loginDemo'), end);

export const loginDemoLink = formatRoute(loginDemoRoute)({});

export const loginLink = isProduction ? formatRoute(loginRoute)({}) : loginDemoLink;

const loginDemoServerRoute = url(lit('login'), lit('demo'), end);
export const loginDemoServerLink = formatRoute(loginDemoServerRoute)({});

const logoutRoute = url(lit('logout'), end);
export const logoutLink = formatRoute(logoutRoute);
